/**
 * Polyfill for Map.prototype.getOrInsertComputed (TC39 Stage 3).
 *
 * Required by pdfjs-dist ≥ 5.6 which uses this API internally.
 * Can be removed once all target browsers ship native support
 * (Chrome 134+, Firefox 134+).
 */
if (typeof Map.prototype.getOrInsertComputed !== "function") {
  Map.prototype.getOrInsertComputed = function <K, V>(
    this: Map<K, V>,
    key: K,
    callbackFn: (key: K) => V
  ): V {
    if (this.has(key)) {
      return this.get(key) as V
    }
    const value = callbackFn(key)
    this.set(key, value)
    return value
  }
}
